import {reducirHash} from "../Funciones/reducirHash";

export const adap_nuevo_contrato_mov = (con) => {

    let obj = {
        tipo: 'Deposito',
        idUsuario: con.idUsuario,
        codigoUsuario: con.codigoUsuario,
        fecha: con.fecha,
        hashString: con.hashString,
        hash: con.hash,
        consecutivo: con.consecutivo,
        nombre: con.nombre,
        valor: con.valor * -1, //Salida de dinero de deposito
        moneda: 'USD',
        departamento: 'Usuario',
        correo: con.correo,
        visible: 'Visible',
        fechaRespuesta: con.fecha,
        detalle: 'Creación de contrato: ' + reducirHash({hash: con.hash, largo: 10}),
    }

    return obj


}